/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React,
{
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import { useMutation, useQuery } from '@apollo/client';
import _ from 'lodash';
import { CenteredLoader, ConfirmDialog, captureException } from '@playbookux/playbook-web-core';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';
import {
  GET_CONTROLS_BY_COMPANY,
  UPDATE_COMPANY_CONTROLS,
  GET_OVERRIDEN_WORKSPACES,
  RESET_WORKSPACES,
  handleUpdateCompanyControlsMutationUpdate,
  handleResetWorkspacesUpdate,
  GET_ALL_SEND_CONTROLS,
} from '../../../core/graphql/controls';

import {
  UPDATE_STUDY_STATUS_BY_COMPANY,
} from '../approvals/approval-participant/status/graphql';
import { GET_ALL_COMPANIES, DEBOUNCE_TIME } from '../../../core/graphql/companies';
import useDebounce from '../../../core/hooks/use-debounce';

import {
  Button,
  ButtonContainer,
  Container,
  Header,
  Dropdown,
  Popup,
  Table,
  Text,
} from './styles';

import Cell from './cell';

const GLOBAL_COMPANY = 'global';

const Controls = () => {
  const [unmodIosSend, setUnmodIosSend] = useState(true);
  const [unmodIosApprove, setUnmodIosApprove] = useState(true);
  const [unmodAndroidSend, setUnmodAndroidSend] = useState(true);
  const [unmodAndroidApprove, setUnmodAndroidApprove] = useState(true);
  const [toggleOn] = useState([]);

  const [unmodMacosSend, setUnmodMacosSend] = useState(true);
  const [unmodMacosApprove, setUnmodMacosApprove] = useState(true);

  const [unmodWindowsSend, setUnmodWindowsSend] = useState(true);
  const [unmodWindowsApprove, setUnmodWindowsApprove] = useState(true);

  const [unmodConsumerSend, setUnmodConsumerSend] = useState(true);
  const [unmodConsumerApprove, setUnmodConsumerApprove] = useState(true);

  const [unmodProfessionalSend, setUnmodProfessionalSend] = useState(true);
  const [unmodProfessionalApprove, setUnmodProfessionalApprove] = useState(true);

  const [modSend, setModSend] = useState(true);
  const [modApprove, setModApprove] = useState(true);
  const [modDidNotShow, setModDidNotShow] = useState(true);

  const [cardsortSend, setCardsortSend] = useState(true);
  const [cardsortApprove, setCardsortApprove] = useState(true);

  const [treeSend, setTreeSend] = useState(true);
  const [treeApprove, setTreeApprove] = useState(true);

  const [surveySend, setSurveySend] = useState(true);
  const [surveyApprove, setSurveyApprove] = useState(true);

  const [companyId, setCompanyId] = useState(GLOBAL_COMPANY);

  const [currentWorkspaceState, setCurrentWorkspaceState] = useState(null);

  const [showConfirm, setShowConfirm] = useState(false);
  const [showRevert, setShowRevert] = useState(false);
  const [showRevertAll, setShowRevertAll] = useState(false);
  const [chars, setChars] = useState('');
  const [debouncedSearch] = useDebounce(() => chars, DEBOUNCE_TIME, [chars]);

  const { loading: loadingCompanies, data: dataCompanies } = useQuery(
    GET_ALL_COMPANIES,
    {
      variables: {
        limit: 50,
        offset: 0,
        order: 'name ASC',
        search: debouncedSearch,
      },
    },
  );

  const { loading, data } = useQuery(GET_CONTROLS_BY_COMPANY, {
    variables: {
      companyId: companyId === GLOBAL_COMPANY ? null : companyId,
    },
    fetchPolicy: 'network-only',
  });

  const { data: overridenWorkspacesData } = useQuery(GET_OVERRIDEN_WORKSPACES);
  const { overridenWorkspaces = [] } = overridenWorkspacesData || {};

  const [updateControls, { loading: loadingUpdate }] = useMutation(UPDATE_COMPANY_CONTROLS, {
    update: handleUpdateCompanyControlsMutationUpdate,
  });

  const [updateStudyStatusByCompany] = useMutation(UPDATE_STUDY_STATUS_BY_COMPANY);

  const [resetWorkspaces, { loading: loadingReset }] = useMutation(RESET_WORKSPACES, {
    update: handleResetWorkspacesUpdate,
  });

  const handleSearchChange = (e, { searchQuery }) => {
    setChars(_.trim(searchQuery));
  };

  const handleChangeWorkspace = (val) => {
    setCompanyId(val);
  };

  const handleRevert = useCallback(() => {
    setUnmodIosSend(currentWorkspaceState.iosSend);
    setUnmodIosApprove(currentWorkspaceState.iosApprove);

    setUnmodAndroidSend(currentWorkspaceState.androidSend);
    setUnmodAndroidApprove(currentWorkspaceState.androidApprove);

    setUnmodMacosSend(currentWorkspaceState.macosSend);
    setUnmodMacosApprove(currentWorkspaceState.macosApprove);

    setUnmodWindowsSend(currentWorkspaceState.windowsSend);
    setUnmodWindowsApprove(currentWorkspaceState.windowsApprove);

    setUnmodConsumerSend(currentWorkspaceState.unmodConsumerSend);
    setUnmodConsumerApprove(currentWorkspaceState.unmodConsumerApprove);

    setUnmodProfessionalSend(currentWorkspaceState.unmodProfessionalSend);
    setUnmodProfessionalApprove(currentWorkspaceState.unmodProfessionalApprove);

    setModSend(currentWorkspaceState.modSend);
    setModApprove(currentWorkspaceState.modApprove);
    setModDidNotShow(currentWorkspaceState.modDidNotShow);

    setCardsortSend(currentWorkspaceState.cardSortSend);
    setCardsortApprove(currentWorkspaceState.cardSortApprove);

    setTreeSend(currentWorkspaceState.treeTestSend);
    setTreeApprove(currentWorkspaceState.treeTestApprove);

    setSurveySend(currentWorkspaceState.surveySend);
    setSurveyApprove(currentWorkspaceState.surveyApprove);

    setCompanyId(companyId === GLOBAL_COMPANY ? GLOBAL_COMPANY : companyId);

    setShowRevert(false);
  }, [
    currentWorkspaceState?.androidApprove,
    currentWorkspaceState?.cardSortApprove,
    currentWorkspaceState?.cardSortSend,
    currentWorkspaceState?.iosApprove,
    currentWorkspaceState?.iosSend,
    currentWorkspaceState?.macosApprove,
    currentWorkspaceState?.macosSend,
    currentWorkspaceState?.modApprove,
    currentWorkspaceState?.modDidNotShow,
    currentWorkspaceState?.modSend,
    currentWorkspaceState?.surveyApprove,
    currentWorkspaceState?.surveySend,
    currentWorkspaceState?.treeTestApprove,
    currentWorkspaceState?.treeTestSend,
    currentWorkspaceState?.unmodConsumerApprove,
    currentWorkspaceState?.unmodConsumerSend,
    currentWorkspaceState?.unmodProfessionalApprove,
    currentWorkspaceState?.unmodProfessionalSend,
    currentWorkspaceState?.windowsApprove,
    currentWorkspaceState?.windowsSend,
  ]);

  useEffect(() => {
    if (currentWorkspaceState && companyId !== GLOBAL_COMPANY) {
      setUnmodIosSend(currentWorkspaceState.iosSend);
      setUnmodIosApprove(currentWorkspaceState.iosApprove);

      setUnmodAndroidSend(currentWorkspaceState.androidSend);
      setUnmodAndroidApprove(currentWorkspaceState.androidApprove);

      setUnmodMacosSend(currentWorkspaceState.macosSend);
      setUnmodMacosApprove(currentWorkspaceState.macosApprove);

      setUnmodWindowsSend(currentWorkspaceState.windowsSend);
      setUnmodWindowsApprove(currentWorkspaceState.windowsApprove);

      setUnmodConsumerSend(currentWorkspaceState.unmodConsumerSend);
      setUnmodConsumerApprove(currentWorkspaceState.unmodConsumerApprove);

      setUnmodProfessionalSend(currentWorkspaceState.unmodProfessionalSend);
      setUnmodProfessionalApprove(currentWorkspaceState.unmodProfessionalApprove);

      setModSend(currentWorkspaceState.modSend);
      setModApprove(currentWorkspaceState.modApprove);
      setModDidNotShow(currentWorkspaceState.modDidNotShow);

      setCardsortSend(currentWorkspaceState.cardSortSend);
      setCardsortApprove(currentWorkspaceState.cardSortApprove);

      setTreeSend(currentWorkspaceState.treeTestSend);
      setTreeApprove(currentWorkspaceState.treeTestApprove);

      setSurveySend(currentWorkspaceState.surveySend);
      setSurveyApprove(currentWorkspaceState.surveyApprove);
    }
  }, [currentWorkspaceState]);

  const handleSave = useCallback(async (controlsData) => {
    try {
      await updateControls({
        variables: {
          companyId: companyId === GLOBAL_COMPANY ? null : companyId,
          attributes: {
            iosSend: unmodIosSend,
            iosApprove: unmodIosApprove,
            androidSend: unmodAndroidSend,
            androidApprove: unmodAndroidApprove,
            macosSend: unmodMacosSend,
            macosApprove: unmodMacosApprove,
            windowsSend: unmodWindowsSend,
            windowsApprove: unmodWindowsApprove,
            cardSortSend: cardsortSend,
            cardSortApprove: cardsortApprove,
            treeTestSend: treeSend,
            treeTestApprove: treeApprove,
            surveySend,
            surveyApprove,
            modSend,
            modApprove,
          },
        },
      });

      let globalCompaniesIds = [];
      if (companyId === GLOBAL_COMPANY) {
        // company ids using global
        const updateCondition = Object.entries(toggleOn);
        // return ids of companys that has value "false" in the buttons that were turned "on"
        globalCompaniesIds = controlsData.playbookuxSendControls.filter((v) => {
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, val] of updateCondition) {
            if (key in v && v[key] !== val) return true;
          }
          return false;
        }).map((val) => val.id);
      }
      await updateStudyStatusByCompany({
        variables: {
          companyId: companyId === GLOBAL_COMPANY ? null : companyId,
          globalIds: globalCompaniesIds,
          attributes: {
            iosSend: unmodIosSend,
            androidSend: unmodAndroidSend,
            macosSend: unmodMacosSend,
            windowsSend: unmodWindowsSend,
            cardSortSend: cardsortSend,
            treeTestSend: treeSend,
          },
        },
      });
      setShowConfirm(false);
    } catch (err) {
      captureException('UPDATE_STUDY_STATUS_BY_COMPANY_FAILURE', err);
    }
  }, [
    updateControls,
    updateStudyStatusByCompany,
    companyId,
    unmodIosSend,
    unmodIosApprove,
    unmodAndroidSend,
    unmodAndroidApprove,
    unmodMacosSend,
    unmodMacosApprove,
    unmodWindowsSend,
    unmodWindowsApprove,
    unmodConsumerSend,
    unmodConsumerApprove,
    unmodProfessionalSend,
    unmodProfessionalApprove,
    modSend,
    modApprove,
    modDidNotShow,
    cardsortSend,
    cardsortApprove,
    treeSend,
    treeApprove,
    surveySend,
    surveyApprove,
  ]);

  const {
    data: controlsData,
  } = useQuery(GET_ALL_SEND_CONTROLS);

  const handleRevertAll = useCallback(async () => {
    try {
      const { data: { resetWorkspaces: { playbookuxControl: globalControl } } } = await resetWorkspaces();
      const currentControls = {};

      Object.entries(globalControl).map(([k]) => {
        if (k !== '__typename') {
          currentControls[k] = true;
        }
      });

      setCurrentWorkspaceState(currentControls);
      setShowRevertAll(false);
    } catch (err) {
      captureException('HANDLE_RESET_REVERT_ALL_FAILURE', err);
    }
  });

  const workspaces = useMemo(() => {
    let newOptions = [];
    if (dataCompanies && dataCompanies.companies) {
      newOptions = dataCompanies.companies.map(({ id, name }) => ({
        key: id,
        text: name,
        value: id,
      }));
    }
    return [
      {
        key: GLOBAL_COMPANY,
        text: 'All Workspaces',
        value: GLOBAL_COMPANY,
      },
    ].concat(newOptions);
  }, [dataCompanies]);

  useEffect(() => {
    if (data) {
      setCurrentWorkspaceState(data.playbookuxControls);
      setUnmodIosSend(data.playbookuxControls.iosSend);
      setUnmodIosApprove(data.playbookuxControls.iosApprove);
      setUnmodAndroidSend(data.playbookuxControls.androidSend);
      setUnmodAndroidApprove(data.playbookuxControls.androidApprove);
      setUnmodMacosSend(data.playbookuxControls.macosSend);
      setUnmodMacosApprove(data.playbookuxControls.macosApprove);
      setUnmodWindowsSend(data.playbookuxControls.windowsSend);
      setUnmodWindowsApprove(data.playbookuxControls.windowsApprove);
      setUnmodConsumerSend(data.playbookuxControls.unmodConsumerSend);
      setUnmodConsumerApprove(data.playbookuxControls.unmodConsumerApprove);
      setUnmodProfessionalSend(data.playbookuxControls.unmodProfessionalSend);
      setUnmodProfessionalApprove(data.playbookuxControls.unmodProfessionalApprove);
      setModSend(data.playbookuxControls.modSend);
      setModApprove(data.playbookuxControls.modApprove);
      setModDidNotShow(data.playbookuxControls.modDidNotShow);
      setCardsortSend(data.playbookuxControls.cardSortSend);
      setCardsortApprove(data.playbookuxControls.cardSortApprove);
      setTreeSend(data.playbookuxControls.treeTestSend);
      setTreeApprove(data.playbookuxControls.treeTestApprove);
      setSurveySend(data.playbookuxControls.surveySend);
      setSurveyApprove(data.playbookuxControls.surveyApprove);
    }
  }, [data]);

  const checkToggleOn = (toggle) => {
    const found = toggleOn.some((val) => Object.keys(toggle)[0] in val);
    if (!found && Object.values(toggle)[0]) {
      toggleOn.push(toggle);
    }
  };
  if (loading) {
    return <CenteredLoader />;
  }

  return (
    <Container>
      <Header>
        <Dropdown
          loading={loadingCompanies}
          onChange={(e, { value }) => handleChangeWorkspace(value)}
          onSearchChange={handleSearchChange}
          options={workspaces}
          search
          selection
          value={companyId}
        />

        {!_.isEmpty(overridenWorkspaces) && (
          <div className="details">
            <Popup
              content={(
                <div>
                  {overridenWorkspaces.map(({ company: { name } }) => (
                    <Text style={{ marginBottom: 4 }}>{name}</Text>
                  ))}
                </div>
              )}
              trigger={(
                <Text>
                  {overridenWorkspaces.length}
                  {' '}
                  workspaces are different than global
                </Text>
              )}
              position="bottom center"
            />

            <Button onClick={() => setShowRevertAll(true)}>
              Reset all to global
            </Button>
          </div>
        )}

      </Header>

      <Table celled structured basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <Text.Header />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Header>Automatically send testers studies</Text.Header>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Header>Automatically approve videos</Text.Header>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Header>Automatically recruit did not shows</Text.Header>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <Text.Header>Unmoderated</Text.Header>
            </Table.Cell>
            <Table.Cell />
            <Table.Cell />
            <Table.Cell />
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>iOS</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodIosSend"
                checked={unmodIosSend}
                onChange={() => { setUnmodIosSend(!unmodIosSend); checkToggleOn({ iosSend: !unmodIosSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodIosApprove"
                checked={unmodIosApprove}
                onChange={() => setUnmodIosApprove(!unmodIosApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Android</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodAndroidSend"
                checked={unmodAndroidSend}
                onChange={() => { setUnmodAndroidSend(!unmodAndroidSend); checkToggleOn({ androidSend: !unmodAndroidSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodAndroidApprove"
                checked={unmodAndroidApprove}
                onChange={() => setUnmodAndroidApprove(!unmodAndroidApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Macos</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodMacosSend"
                checked={unmodMacosSend}
                onChange={() => { setUnmodMacosSend(!unmodMacosSend); checkToggleOn({ macosSend: !unmodMacosSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodMacosApprove"
                checked={unmodMacosApprove}
                onChange={() => setUnmodMacosApprove(!unmodMacosApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Windows</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodWindowsSend"
                checked={unmodWindowsSend}
                onChange={() => { setUnmodWindowsSend(!unmodWindowsSend); checkToggleOn({ windowsSend: !unmodWindowsSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="unmodWindowsApprove"
                checked={unmodWindowsApprove}
                onChange={() => setUnmodWindowsApprove(!unmodWindowsApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Text.Header>Moderated</Text.Header>
            </Table.Cell>
            <Table.Cell />
            <Table.Cell />
            <Table.Cell />
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Moderated</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="modSend"
                checked={modSend}
                onChange={() => { setModSend(!modSend); checkToggleOn({ modSend: !modSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="modApprove"
                checked={modApprove}
                onChange={() => setModApprove(!modApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Card sort</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="cardsortSend"
                checked={cardsortSend}
                onChange={() => { setCardsortSend(!cardsortSend); checkToggleOn({ cardSortSend: !cardsortSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="cardsortApprove"
                checked={cardsortApprove}
                onChange={() => setCardsortApprove(!cardsortApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Tree test</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="treeSend"
                checked={treeSend}
                onChange={() => { setTreeSend(!treeSend); checkToggleOn({ treeTestSend: !treeSend }); }}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="treeApprove"
                checked={treeApprove}
                onChange={() => setTreeApprove(!treeApprove)}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.Cell>
              <Text.Header>Survey</Text.Header>
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="surveySend"
                checked={surveySend}
                onChange={() => setSurveySend(!surveySend)}
              />
            </Table.Cell>
            <Table.Cell>
              <Cell
                companyId={companyId}
                name="surveyApprove"
                checked={surveyApprove}
                onChange={() => setSurveyApprove(!surveyApprove)}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <ButtonContainer>
        <div>
          <Button.Inverted onClick={() => setShowRevert(true)}>
            Revert Changes
          </Button.Inverted>
        </div>
        <div>
          <Button onClick={() => setShowConfirm(true)} loading={loadingUpdate}>
            Save
          </Button>
        </div>
      </ButtonContainer>

      <ConfirmDialog
        show={showConfirm}
        title="Are you sure you want to save?"
        titleTextColor="black"
        confirmText="Save"
        confirmTextColor="white"
        confirmTextBackgroundColor="#477AE9"
        cancelText="Don't Save"
        cancelTextColor="white"
        cancelTextBackgroundColor="#477AE9"
        handleConfirm={() => handleSave(controlsData)}
        handleClose={() => setShowConfirm(false)}
        loading={loadingUpdate}
      />

      <ConfirmDialog
        show={showRevert}
        title="Are you sure you want to revert?"
        titleTextColor="black"
        confirmText="Revert"
        confirmTextColor="white"
        confirmTextBackgroundColor="#477AE9"
        cancelText="Don't revert"
        cancelTextColor="white"
        cancelTextBackgroundColor="#477AE9"
        handleConfirm={handleRevert}
        handleClose={() => setShowRevert(false)}
      />

      <ConfirmDialog
        show={showRevertAll}
        loading={loadingReset}
        title="Are you sure you want to reset workspaces to global settings?"
        titleTextColor="black"
        confirmText="Yes, reset"
        confirmTextColor="white"
        confirmTextBackgroundColor="#477AE9"
        cancelText="No, don't reset"
        cancelTextColor="white"
        cancelTextBackgroundColor="#477AE9"
        handleConfirm={handleRevertAll}
        handleClose={() => setShowRevertAll(false)}
      />
    </Container>
  );
};

export default withDashboardSidebar(Controls);
